export default {
  title_top: '联系我们',
  title_bottom: '感谢您的垂询',
  desc: '系统收到您的提交内容之后，\t会自动向您的邮箱发送一封邮件。\n\n'
      + '近期将会有工作人员与您联系，\t请耐心等待。\t如果您长时间没有收到联系，\t请拨打电话咨询。',
};
